module.exports = __webpack_public_path__ + "static/media/29EUNOG17.87b86528.jpg";